import { useMemo } from 'react';

type RetentionDateLimits = {
  minDate: Date;
  maxDate: Date;
};

export function useRetentionDateLimits(
  retentionValue?: number
): RetentionDateLimits {
  const minDate = useMemo(() => {
    const date = new Date();
    date.setUTCDate(date.getUTCDate() - (retentionValue ?? 3));
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }, [retentionValue]);

  const maxDate = useMemo(() => {
    const date = new Date();
    date.setUTCHours(23, 59, 59, 999);
    return date;
  }, []);

  return { minDate, maxDate };
}
